import {makeActionCreator} from '../../redux-toolbelt';

export const toggleContrastMode = makeActionCreator<'toggleContrastMode', never>('toggleContrastMode');
export const toggleOutlieMode = makeActionCreator<'toggleOutlieMode', never>('toggleOutlieMode');
